import { type ReactNode } from 'react';

function Slab(): ReactNode {
  return <div className="h-[72px] animate-pulse rounded-md bg-white/[0.04]" />;
}

export function PaymentColumnSkeleton({ count }: { count: number }): ReactNode {
  return (
    <div className="animate-fade-in space-y-sm">
      {Array.from({ length: count }, (_, i) => (
        <Slab key={i} />
      ))}
    </div>
  );
}
